import o from "./index609.js";
import t from "./index610.js";
import { withInstall as m, withNoopInstall as r } from "./index604.js";
const f = m(o, {
  ButtonGroup: t
});
r(t);
export {
  f as ElButton,
  f as default
};
